// extracted by mini-css-extract-plugin
module.exports = {"divCentro":"Inicio_divCentro__Gnpra","sombraCard":"Inicio_sombraCard__ULKf0","cardAtalho":"Inicio_cardAtalho__3ui2z"};